import {
  Box,
  Flex,
  Spacer,
  VStack,
  Text,
  Avatar,
  Button,
  Icon,
  MenuButton,
  MenuList,
  MenuItem,
  Menu,
  IconButton,
} from '@chakra-ui/react';
import { MdMenu } from 'react-icons/md';

import shallow from 'zustand/shallow';
import { useAuth } from '../../lib/auth-provider/context';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { useListAcademicYear } from '../../modules/school/academic-year/context/hooks';
import { Select } from '../../lib/components';
import { useSettingList } from '../../modules/setting/context/hooks';
import { useAcademicYears } from '../../common/contexts';
import { useEffect } from 'react';
import moment from 'moment';
import { FiSettings } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

function AppBar({
  onToggleNavigationDrawer,
  navigationDrawerWidth,
  ...properties
}) {
  const navigate = useNavigate();
  const [user] = useAuth((state) => [state.user], shallow);
  const [academicYear, setAcademicYear] = useAcademicYears(
    (state) => [state.academicYear, state.setAcademicYear],
    shallow,
  );
  const { fullname } = user;
  const { data } = useSettingList({
    page: 1,
  });
  const valueData = data?.data;
  const {
    data: academicYears,
    refetch,
    status,
    isFetching,
  } = useListAcademicYear({
    limit: 1000,
    queryKey: 'FECTH_ACADEMICYEARS_NAV',
  });

  // console.log('Academic Years', academicYears?.data?.docs);

  const academicYearOptions =
    academicYears?.data?.docs?.map((item) => ({
      label: item.fullName,
      value: item.id,
    })) || [];

  const today = moment().startOf('day');

  const semesterBerlangsung = academicYears?.data?.docs?.filter((semester) => {
    return moment().isBetween(
      moment(semester.startSemester),
      moment(semester.endSemester),
    );
  });

  useEffect(() => {
    refetch();
  }, [user]);
  // console.log({ semesterBerlangsung });

  useEffect(() => {
    if (status === 'success' && academicYears?.data?.docs) {
      if (semesterBerlangsung?.length > 0) {
        // Set to current active semester if available
        setAcademicYear(semesterBerlangsung[0]?.id);
      } else if (!academicYear && academicYears.data.docs.length > 0) {
        // If no active semester and no academic year set, use the most recent one
        const lastAcademicYear =
          academicYears.data.docs[academicYears.data.docs.length - 1];
        setAcademicYear(lastAcademicYear.id);
      }
    }
  }, [status, academicYears, academicYear, semesterBerlangsung]);

  return (
    <Box
      as="header"
      height="64px"
      marginTop="0"
      transform="translateY(0px)"
      borderBottom="1px solid #e6e6e6"
      position="fixed"
      top={0}
      right={0}
      zIndex={5}
      py="18px"
      px="25px"
      display="flex"
      alignItems="center"
      backgroundColor="white"
      left={{ base: '0', md: navigationDrawerWidth }}
      {...properties}
    >
      <Button
        display={{ base: 'block', md: 'none' }}
        variant="ghost"
        p={1}
        onClick={onToggleNavigationDrawer}
      >
        <Icon as={MdMenu} width="28px" height="28px" />
      </Button>
      <Select
        id="idAcademicYears"
        placeholder={
          academicYearOptions.length === 0
            ? 'Tahun Ajaran Belum Tersedia'
            : undefined
        }
        inputProps={{
          size: 'sm',
          bgColor: 'white',
        }}
        value={academicYear}
        onChange={(e) => {
          setAcademicYear(e.target.value);
        }}
        options={academicYearOptions}
      />
      <Spacer />
      <Flex gap={4} align="center">
        <VStack align="start" spacing="2px" gap={1}>
          <Text
            fontSize="sm"
            lineHeight={5}
            fontWeight="bold"
            textTransform="capitalize"
          >
            {fullname}
          </Text>
        </VStack>
        <IconButton
          size="sm"
          variant="ghost"
          color="cyan.700"
          aria-label="Settings"
          icon={<FiSettings />}
          onClick={() => navigate('/settings')}
          mr={2}
        />
        <Avatar
          width="32px"
          height="32px"
          name="Kent Dodds"
          src={valueData?.photo}
        />
      </Flex>
    </Box>
  );
}

export { AppBar };
